/**
 * Single source of truth for "Updated X ago" copy across the app.
 * Use this wherever we show last-refreshed time so wording stays consistent.
 *
 * @param {number} timestamp - Unix ms (Date.now() or from cache)
 * @returns {string} e.g. "just now", "1 min ago", "3 mins ago", "1 hour ago"
 */
export function formatUpdatedAgo(timestamp) {
  if (timestamp == null || typeof timestamp !== 'number') return '';
  const diff = Date.now() - timestamp;
  const seconds = Math.floor(diff / 1000);
  // Treat anything under a minute as "just now" so dashboards
  // don't over-precision the copy in the first few seconds.
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(diff / 60000);
  if (minutes === 1) return '1 min ago';
  if (minutes < 60) return `${minutes} mins ago`;
  const hours = Math.floor(minutes / 60);
  if (hours === 1) return '1 hour ago';
  return `${hours} hours ago`;
}

/**
 * Format a timestamp as exact time only (no "just now" or relative).
 * Use when we must not lie about when data was actually updated.
 *
 * @param {number} timestamp - Unix ms
 * @returns {string} e.g. "10:45"
 */
export function formatExactTime(timestamp) {
  if (timestamp == null || typeof timestamp !== 'number') return '';
  const date = new Date(timestamp);
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
}
